'use client'

import { useCustomImageContext } from '@/contexts/CustomImageContext'
import { useNonUrlContext } from '@/contexts/NonUrlContext'
import { useProductDetailPageContext } from '@/contexts/ProductDetailPageContext'
import { useCart } from '@/hooks/useCart'
import { ShoppingCart } from 'lucide-react'

type Props = {
    productID: number
}

export default function AddToCartButton(props: Props) {

    const [customImgCtx, _] = useCustomImageContext()
    const cart = useCart()
    const nonURIContext = useNonUrlContext()
    const [productDetailCtx, __] = useProductDetailPageContext()


    const handleClick = () => {
        cart.addToCart(props.productID, customImgCtx, productDetailCtx.qty, nonURIContext.selectedSize?.id, nonURIContext.selectedColor?.id)
    }

    return (
        <button className="bg-ffaccent-600 hover:bg-ffaccent-700 group text-ffaccent-100 px-5 py-3 rounded-full flex items-center justify-center transition-all duration-200"
            onClick={handleClick}
            disabled={cart.loading}
            id="add-to-cart-button"
        >
            <ShoppingCart className='mx-2 fill-transparent group-hover:fill-ffaccent-200 transition-all duration-200 ' />
            <span className='font-semibold'>
                Add to Cart
            </span>
            {cart.loading && <span className="loading loading-spinner loading-sm mx-2" />}
        </button>
    )
}
